import { useSite } from "@/context/SiteContext";
import { useCart } from "@/context/CartContext";
import { useLang } from "@/i18n/LanguageContext";

/* Pre-launch every buy button becomes "Notify me" and opens the one sign-up offer. */
export const BuyButton = ({ productIds, qty = 1, label, className = "btn-primary w-full", testid, disabled = false }) => {
  const { orderingOpen, notify } = useSite();
  const { add } = useCart();
  const { t } = useLang();
  const ids = Array.isArray(productIds) ? productIds : [productIds];
  const onClick = () => {
    if (!orderingOpen) return notify(ids[0]);
    ids.forEach((id, i) => add(id, qty, i === ids.length - 1));
    return undefined;
  };
  return (
    <button type="button" onClick={onClick} disabled={disabled} className={className} data-testid={testid} data-no-translate>
      {orderingOpen ? (label || t("Add to cart", "Ajouter au panier")) : t("Notify me", "M'avertir")}
    </button>
  );
};
